import React, { useEffect, useState } from 'react';
import { MemberStats } from '@/data/mockDashboardData';
import { UserPlus, UserCheck, UserX } from 'lucide-react';
import { DashboardMemberCardAPI } from '@/api/type';
import { getDashboardMemberCard } from '@/api/Dashboard';
import { useTranslation } from 'react-i18next';

interface MemberStatsTabsProps {
}

type Period = 'today' | '7_days' | '30_days';

export const MemberStatsTabs = () => {
  const { t } = useTranslation();
  const [data, setData] = useState< DashboardMemberCardAPI | null>(null);


  const statItems = [
    {
      label: t('dashboard.new_members'),
      sublabel: '',
      value: data?.data.new_members?.toString() || '0',
      icon: <UserPlus />,
      color: 'text-blue-500',
      iconBgColor: 'bg-blue-100 dark:bg-blue-900/20',
      cardBgColor: 'bg-blue-50/50 dark:bg-blue-900/10',
      borderColor: 'border-blue-100 dark:border-blue-900/30',
    },
    {
      label: t('dashboard.active_members'),
      sublabel: '',
      value: data?.data.active_members?.toString() || '0',
      icon: <UserCheck />,
      color: 'text-green-500',
      iconBgColor: 'bg-green-100 dark:bg-green-900/20',
      cardBgColor: 'bg-green-50/50 dark:bg-green-900/10',
      borderColor: 'border-green-100 dark:border-green-900/30',
    },
    {
      label: t('dashboard.banned_suspended'),
      sublabel: t('dashboard.banned_count', { count: data?.data.banned_members || 0 }),
      value: data?.data.banned_members?.toString() || '0',
      icon: <UserX />,
      color: 'text-red-500',
      iconBgColor: 'bg-red-100 dark:bg-red-900/20',
      cardBgColor: 'bg-red-50/50 dark:bg-red-900/10',
      borderColor: 'border-red-100 dark:border-red-900/30',
    },
  ];

  useEffect (() => {
    // Fetch data from API based on activePeriod
    getDashboardMemberCard().then(response => {
      setData(response);
    }).catch(() => {
      setData(null);
    });

  }, []);

  return (
    <div className="!bg-white dark:!bg-dark-card rounded-xl shadow-sm border border-gray-200 dark:border-dark-border">
      <div className="px-6 pt-6 flex sm:items-center items-start sm:justify-between justify-start flex-col sm:flex-row">
        <h2 className="text-xl font-bold !text-gray-900 dark:!text-white">
          {t('dashboard.member_stats')}
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-6">
        {statItems.map((item, index) => (
          <div
            key={index}
            className={`p-4 rounded-md border ${item.cardBgColor} ${item.borderColor}`}
          >
            <div className="flex items-start space-x-4">
              <div className={`p-4 rounded-md ${item.iconBgColor} ${item.color}`}>
                {React.cloneElement(item.icon, { className: 'w-6 h-6' })}
              </div>
              <div className="flex-1">
                <p className="text-base font-semibold !text-gray-900 dark:!text-white mb-1">
                  {item.label}
                </p>
                <p className="text-sm !text-gray-500 dark:!text-dark-text-muted">
                  {item.sublabel}
                </p>
              </div>
            </div>

            <div className="mt-1 pl-1">
              <p className="text-2xl md:text-3xl font-bold !text-gray-900 dark:!text-white !mb-0">
                {item.value}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
